import Vue from 'vue'
import Vuex from 'vuex'
import addSeconds from 'date-fns/add_seconds'
import isPast from 'date-fns/is_past'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import Cookies from 'cookies-js'
import API from '@/lib/api'

Vue.use(Vuex)

const clientID = 'gs9yoVyinLyZyGdHr_A0FNBJQ5fTMBCza_D1Nd_FlI3guadwAwJp9mqyssp-aa1-UucarTatKystO0o1w4eWkg'

export default new Vuex.Store({
  state: {
    auth: {
      access_token: Cookies.get('access_token'),
      access_token_expires: (Cookies.get('access_token_expires') != null ? parse(Cookies.get('access_token_expires')) : null),
      refresh_token: Cookies.get('refresh_token')
    },
    user: {
      id: null,
      name: null,
      email: null,
      company: null,
      teams: [],
      is_service_wide_admin: false,
      service_wide_permissions: [],
      team_users: [],
      company_users: []
    },
    currentTeam: null,
    adminCompany: null
  },
  getters: {
    isLoggedIn: state => {
      return state.auth.refresh_token != null
    },
    authHeaders: state => {
      if (state.auth != null && state.auth.access_token != null) {
        return { Authorization: 'Bearer ' + state.auth.access_token }
      } else {
        return {}
      }
    },
    teams: state => {
      return state.user.teams
    },
    workflows: state => {
      var workflows = []
      state.user.teams.forEach((team) => {
        team.owned_workflows.forEach((workflow) => {
          if (workflows.find((w) => { return w.id === workflow.id }) == null) {
            workflows.unshift(workflow)
          }
        })
      })
      return workflows
    }
  },
  mutations: {
    login (state, data) {
      var expiresAt = addSeconds(new Date(), data.expires_in - 60)
      Cookies.set('access_token', data.access_token)
      Cookies.set('access_token_expires', format(expiresAt))
      Cookies.set('refresh_token', data.refresh_token)
      state.auth = { access_token: data.access_token, access_token_expires: expiresAt, refresh_token: data.refresh_token }
      state.user = {
        id: null,
        name: null,
        email: null,
        company: null,
        teams: [],
        is_service_wide_admin: false,
        service_wide_permissions: [],
        team_users: [],
        company_users: []
      }
    },
    updateUser (state, user) {
      state.user = {
        id: user.id,
        name: user.name,
        email: user.email,
        company: user.company,
        teams: user.teams,
        is_service_wide_admin: user.is_service_wide_admin,
        service_wide_permissions: user.service_wide_permissions,
        team_users: user.team_users,
        company_users: user.company_users
      }
      if (user.teams.length > 0) {
        state.currentTeam = user.teams[0]
      } else {
        state.currentTeam = null
      }
    },
    selectCurrentTeam (state, team) {
      state.currentTeam = team
    },
    logout (state) {
      Cookies.expire('access_token')
      Cookies.expire('access_token_expires')
      Cookies.expire('refresh_token')
      state.auth = { access_token: null, access_token_expires: null, refresh_token: null }
      state.user = { id: null, name: null, email: null, company: null, teams: [], permissions: [] }
      state.currentTeam = null
    }
  },
  actions: {
    ensureLoggedIn ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (this.getters.isLoggedIn) {
          resolve()
        } else {
          reject(new Error('Not Logged In'))
        }
      }).then(() => {
        return this.dispatch('ensureAccessTokenIsValid')
      }).then(() => {
        return this.dispatch('ensureUserDataAvailable')
      })
    },
    logInIfPossible ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (this.getters.isLoggedIn) {
          resolve()
        } else {
          resolve()
        }
      }).then(() => {
        return this.dispatch('ensureAccessTokenIsValid')
      }).then(() => {
        return this.dispatch('ensureUserDataAvailable')
      }).catch((error) => {
        console.log(error)
        return new Promise((resolve, reject) => {
          resolve()
        })
      })
    },
    ensureAccessTokenIsValid ({ commit, state }) {
      if (state.auth.refresh_token != null &&
        (state.auth.access_token_expires == null || isPast(state.auth.access_token_expires) || state.auth.access_token == null)) {
        return API.postRaw('oauth/token', {grant_type: 'refresh_token', client_id: clientID, refresh_token: state.auth.refresh_token}).then((response) => {
          if (response.data != null) {
            commit('login', response.data)
          }
        }).catch((error) => {
          console.log(error)
          commit('logout')
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
    },
    ensureUserDataAvailable ({ commit, state }) {
      if (state.user.id != null) {
        return new Promise((resolve, reject) => {
          resolve(state.user)
        })
      } else {
        if (this.getters.isLoggedIn) {
          return API.get('account', {}, this.getters.authHeaders).then((response) => {
            if (response.data != null) {
              commit('updateUser', response.data)
            }
          })
        } else {
          return new Promise((resolve, reject) => {
            resolve()
          })
        }
      }
    },
    forceUserUpdate ({ commit, state }) {
      return API.get('account', {}, this.getters.authHeaders).then((response) => {
        if (response.data != null) {
          commit('updateUser', response.data)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js